import { useEffect, useState } from "react";
import { FullScreenSelectView } from "../../../../components/common/fullScreenSelect";
import { regions } from "../../trivia/RegionSelectionPage";
import { OfferAlertModal } from "../../../../components/loyalty";
import { useHistory } from "react-router-dom";
import { useTheme } from "../../../../hooks";

const LocationChecker = ({ whiteListedLocations }) => {
  const { themeContext, theme } = useTheme();
  const [selectedRegion, setRegion] = useState();
  const [showRegionSelector, setShowRegionSelector] = useState(true);
  const [showCitySelector, setShowCitySelector] = useState(false);
  const [cities, setCities] = useState([])
  const [showAlertModal, setShowAlertModal] = useState(false)
  const history = useHistory()
  const goHome = () => {
    history.push("/home?token=" + JSON.parse(localStorage.getItem("token")));
  };

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const selectRegion = (val) => {
    setRegion(val);
    setShowRegionSelector(false);
  }

  const selectCity = (val) => {
    const foundCity = cities.find(({ value }) => value === val);
    if (!whiteListedLocations.includes(foundCity?.label)) {
      setShowAlertModal(true);
      return;
    }
    setShowCitySelector(false);
  };

  const onCitySelectBackClick = () => {
    setRegion(null);
    setShowRegionSelector(true);
    setShowCitySelector(false);
  };

  useEffect(() => {
    if (selectedRegion !== null && selectedRegion !== undefined) {
      const availableCities = regions.find(({ value }) => value === selectedRegion)?.cities;
      setCities(availableCities);
      setShowCitySelector(true);
    }
  }, [selectedRegion]);

  if (!whiteListedLocations?.length) return (
    <></>
  )

  return (
    <>
      {showAlertModal && (
        <OfferAlertModal
          background={background}
          hideModal={() => {
            setShowAlertModal(false);
            goHome();
          }}
          title="Feature Unavailable in Your Location"
          description={"Sorry, the Spin the Wheel feature is not available in your location!"}

        />
      )}
      {
        showRegionSelector && (
          <FullScreenSelectView
            data={regions}
            setValue={selectRegion}
            closeView={goHome}
            title="Region"
            closeOnSelect={false}
          />
        )
      }

      {
        showCitySelector && (
          <FullScreenSelectView
            data={cities}
            setValue={selectCity}
            closeView={onCitySelectBackClick}
            title="Location"
            closeOnSelect={false}
          />
        )
      }

    </>
  )
};

export default LocationChecker;